<template>
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    viewBox="0 0 26.27 28.84"
  >
    <linearGradient
      id="linear-gradient"
      x1="-3.22"
      y1="32.02"
      x2="17.43"
      y2="11.37"
      gradientUnits="userSpaceOnUse"
    >
      <stop
        offset="0"
        stop-color="#008bee"
      />
      <stop
        offset="1"
        stop-color="#00adee"
      />
    </linearGradient>
    <linearGradient
      id="linear-gradient-2"
      x1="-5.56"
      y1="29.68"
      x2="15.09"
      y2="9.03"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-3"
      x1="-2.16"
      y1="33.08"
      x2="18.49"
      y2="12.43"
      xlink:href="#linear-gradient"
    />
    <linearGradient
      id="linear-gradient-4"
      x1="-4.68"
      y1="30.56"
      x2="15.97"
      y2="9.91"
      gradientTransform="translate(2.9 14.91) rotate(-38.98)"
      xlink:href="#linear-gradient"
    />
    <g>
      <path
        fill="url(#linear-gradient)"
        d="m16.69,17.54c.02.19.06.38.06.58,0,3.38-2.74,6.09-6.06,6.09s-6.12-2.71-6.12-6.09c0-3.09,2.34-5.61,5.36-5.99l1.24-4.71c-.16,0-.31-.02-.47-.02C4.75,7.4,0,12.24,0,18.12s4.75,10.72,10.69,10.72,10.69-4.81,10.69-10.72c0-.96-.14-1.89-.38-2.78l-4.31,2.2Z"
      />
      <g>
        <path
          fill="url(#linear-gradient-2)"
          d="m14.7,10.58c.02-1.07.9-1.92,1.97-1.9.33,0,.65.1.92.25l3.43-4.27-2.02-1.63-6.67,4.27c-.11.07-.18.16-.21.29l-3.18,12.12,6.27-7.8c-.31-.35-.5-.82-.49-1.32Z"
        />
        <path
          fill="url(#linear-gradient-3)"
          d="m17.14,12.55c1.04-.24,1.69-1.28,1.45-2.32-.08-.33-.23-.61-.44-.85l3.46-4.24,2.02,1.63-2.78,7.41c-.05.13-.12.21-.23.27l-11.19,5.65,6.32-7.76c.41.23.9.32,1.4.21Z"
        />
        <rect
          fill="url(#linear-gradient-4)"
          x="18.67"
          y="2.16"
          width="7.71"
          height="2.4"
          transform="translate(7.12 -13.42) rotate(38.98)"
        />
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'LawLabIcon',
}
</script>
